import { Injectable, Inject } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import * as _ from 'lodash';

import { contentHeaders } from 'common/headers';
import {catchError} from 'rxjs/operators';


@Injectable()
export class TermsService extends BaseHttpService {

  public fireAcceptSubj = new Subject<void>();

  public fireAccept = this.fireAcceptSubj.asObservable();

  private accepted: {} = null;

  private rootUrl: string = 'tos';

  clearStoredTerms() {
    this.accepted = null;
  }

  fetchTerms(): Observable<any> {
    return this.http.get(
      `${Config.API}/${this.rootUrl}`
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  accept(tosId: any): Observable<any> {
    const body = JSON.stringify({ tosId });
    this.accepted = null;
    return this.http.post(
      `${Config.API}/${this.rootUrl}/${this.brandService.getBrand()}/accept`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  hasAcceptedLatest(): Observable<any> {
    return new Observable(observer => {
      if (this.accepted && !_.isString(this.accepted)) { // not error string
        observer.next(this.accepted);
        return observer.complete();
      } else {
        this.http.get(`${Config.API}/${this.rootUrl}/${this.brandService.getBrand()}`)

            .pipe(catchError(this.handleError.bind(this)))
          .subscribe((accepted: any) => {
            this.accepted = accepted;
            observer.next(this.accepted);
            observer.complete();
          });
      }
    });
  }

  callAccept(): void {
    this.fireAcceptSubj.next();
  }
}
